import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { Image } from 'expo-image'
import { Text } from 'react-native'
import { Theme } from '@theme'
import { useTheme } from '@react-navigation/native'
import { formatTime, getCommonStyles } from '@utils'
import { Icon } from '../atoms'
import { Note, useGetContactById } from '@hooks'
import { useCurrentUserStore } from '@store'
import { defaultImage } from '@assets'

export const NoteItem = ({
  note,
  onPress,
  isSelected,
}: {
  note: Note
  onPress: (noteId: string) => void
  isSelected?: boolean
}) => {
  const theme = useTheme()
  const styles = getStyles(theme)
  const commonStyles = getCommonStyles(theme)
  const { userID } = useCurrentUserStore()

  const otherAccountId = note.createdByAccountId === userID
    ? note.contactAccountId
    : note.isShared
      ? note.createdByAccountId
      : null
  const { data: contact } = useGetContactById(otherAccountId || '')

  return (
    <TouchableOpacity key={note.id} style={styles.noteItem} onPress={() => onPress(note.id)}>
      <View style={styles.noteContainer}>
        <View style={styles.noteContent}>
          {contact && (
            <View style={[commonStyles.row, styles.contactRow]}>
              <Image
                source={contact.avatarUrl ? { uri: contact.avatarUrl } : defaultImage}
                style={styles.contactAvatar}
                cachePolicy="memory-disk"
                contentFit="cover"
              />
              <Text style={styles.contactName} numberOfLines={1} ellipsizeMode="tail">
                {contact.fullName}
              </Text>
            </View>
          )}
          {!!note.title && <Text style={styles.noteTitle}>{note.title}</Text>}
          <Text style={styles.noteTime}>{formatTime(new Date(note.createdAt))}</Text>
          <Text style={styles.noteText}>{note.content}</Text>
        </View>
        <Icon name="arrow" color={isSelected ? theme.colors.primary : theme.colors.lightGrey} />
      </View>
    </TouchableOpacity>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    noteItem: {
      paddingHorizontal: theme.spacing.sm,
      paddingBottom: theme.spacing.lg,
      marginTop: theme.spacing.lg,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.grey20,
    },
    noteContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
    },
    noteContent: {
      flex: 1,
    },
    contactRow: {
      alignItems: 'center',
      marginBottom: theme.spacing.xs,
    },
    contactAvatar: {
      width: 24,
      height: 24,
      borderRadius: 12,
      marginRight: theme.spacing.sm,
    },
    contactName: {
      flex: 1,
      fontSize: theme.fontSize.medium,
      fontWeight: '600',
      color: theme.colors.text,
    },
    noteTitle: {
      fontSize: theme.fontSize.medium,
      fontWeight: '600',
      color: theme.colors.text,
      marginBottom: 2,
    },
    noteTime: {
      fontSize: theme.fontSize.small,
      color: theme.colors.lightGrey,
      marginBottom: 2,
    },
    noteText: {
      fontSize: theme.fontSize.small,
      color: theme.colors.lightGrey,
      lineHeight: 18,
    },
  })
